import { render } from "./AddGenericExternalLinks.vue?vue&type=template&id=f4a76552&ts=true"
import script from "./AddGenericExternalLinks.vue?vue&type=script&lang=ts"
export * from "./AddGenericExternalLinks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__